import { MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBBtn, MDBModalBody, MDBModalFooter } from 'mdb-react-ui-kit';
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { AppContext } from '../App';
import UserService from '../../services/user-service';
import { User } from 'konect-model';
import UserControlService from '../../services/user-control-service';
import { useNavigate } from 'react-router-dom';

interface UserSettingsProps {
    showState: [boolean, Dispatch<SetStateAction<boolean>>];
}

const UserSettings = (props: UserSettingsProps) => {

    const [show, setShow] = props.showState;
    const { user, setUser } = useContext(AppContext);
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [canDeleteAccount, setCanDeleteAccount] = useState(false);

    const cancel = () => {
        setShow(false);
        setFirstName("");
        setLastName("");
        setPassword("");
        setConfirmPassword("");
    }

    const updateName = async () => {
        // Send minimal payload to avoid unintended project updates
        const userUpdate: any = {
            username: user.username,
            firstName: firstName,
            lastName: lastName
        };
        if (await UserService.updateUser(userUpdate)) {
            setFirstName("");
            setLastName("");
            // Update local user state for immediate reflection in UI (if used)
            const updated = Object.assign(new User(), user, { firstName, lastName });
            setUser(updated);
            UserControlService.showInfoPopup({ title: "Change Successful", content: `Successfully changed your name!`, duration: 5000 });
        }
    }

    const updatePassword = async () => {
        // Send minimal payload to avoid unintended project updates
        const userUpdate: any = {
            username: user.username,
            password: password
        };
        if (await UserService.updateUser(userUpdate)) {
            setPassword("");
            setConfirmPassword("");
            UserControlService.showInfoPopup({ title: "Change Successful", content: `Successfully updated your password!`, duration: 5000 });
        }
    }

    const deleteUser = async () => {
        if (await UserService.deleteUser(user.username)) {
            setShow(false);
            setUser(new User());
            UserControlService.showInfoPopup({ title: "Action Successful", content: `Successfully deleted your account!`, duration: 5000 });
            // Redirect to login after successful account deletion
            navigate('/login', { replace: true });
        };
    }

    const checkIfAccountDeletable = (username: string) => {
        setCanDeleteAccount(user.username === username);
    }

    useEffect(() => {
        if (!show) {
            return
        }
        const input = document.getElementById("delete-input");
        if (input) {
            //@ts-ignore
            input.value = "";
        }
        setCanDeleteAccount(false);
    }, [props.showState])

    useEffect(() => {
        const handleEscape = (event:any) => {
            if (event.key === "Escape" && show) cancel();
        };
    
        document.addEventListener("keydown", handleEscape);
        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [])
    

    return <MDBModal staticBackdrop show={show}>
        <MDBModalDialog size="lg">
            <MDBModalContent>
                <MDBModalHeader>
                    <MDBModalTitle>User Settings</MDBModalTitle>
                    <MDBBtn className='btn-close' color='none' onClick={cancel}></MDBBtn>
                </MDBModalHeader>

                <MDBModalBody style={{ maxHeight: "50vh", overflowY: "auto" }}>
                    {/**
                    <div className="d-flex flex-column mb-3 gap-2">
                        <h2>Change Displayname</h2>
                        <div className="d-flex align-items-center gap-2">
                            <div className="">Enter new first name: </div>
                            <input id='firstname-input' className="form-control w-25" type="text" value={firstName} onChange={(e: any) => setFirstName(e.target.value)} />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <div className="">Enter new last name: </div>
                            <input id='lastname-input' className="form-control w-25" type="text" value={lastName} onChange={(e: any) => setLastName(e.target.value)} />
                        </div>
                    </div>
                    <MDBBtn disabled={!firstName && !lastName} onClick={updateName}>
                        Change Displayname
                    </MDBBtn>
                   
                    <hr />
                    */}
                    <div className="d-flex flex-column mb-3 gap-2">
                        <h2>Change Password</h2>
                        <div className="d-flex align-items-center gap-2">
                            <div className="">Enter new password: </div>
                            <input id='password-input' className="form-control w-25" type="password" autoComplete='new-password' value={password} onChange={(e: any) => setPassword(e.target.value)} />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <div className="">Confirm new password: </div>
                            <input id='confirmPassword-input' className="form-control w-25" type="password" autoComplete='new-password' value={confirmPassword} onChange={(e: any) => setConfirmPassword(e.target.value)} />
                        </div>
                    </div>
                    <MDBBtn disabled={!password || confirmPassword !== password} onClick={updatePassword}>
                        Change Password
                    </MDBBtn>

                    <hr />

                    <div className="d-flex flex-column mb-3 gap-2">
                        <h2>Delete Account</h2>
                        <div className="d-flex align-items-center gap-2">
                            <div className="">Enter your username to enable account deletion.</div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <input id='delete-input' className="form-control w-25" type="text" placeholder='Username' onChange={(e: any) => checkIfAccountDeletable(e.target.value)} />
                        <MDBBtn color="danger" onClick={deleteUser} disabled={!canDeleteAccount}>
                            Delete Account
                        </MDBBtn>
                    </div>


                </MDBModalBody>

                <MDBModalFooter>
                    <MDBBtn onClick={cancel}>
                        Close
                    </MDBBtn>
                </MDBModalFooter>
            </MDBModalContent>

        </MDBModalDialog>
    </MDBModal>
};

export default UserSettings;
